import { Breadcrumb } from 'aui';
import { FoxIconRightSm } from 'aui-biz-icons';
import clsx from 'clsx';
import type React from 'react';
import styles from './DocsBreadcrumb.module.css';

export type DocsBreadcrumbProps = {
  value: {
    key: string;
    name: string;
  }[];
  rightNode?: React.ReactNode;
  className?: string;
};

export function DocsBreadcrumb(props: DocsBreadcrumbProps) {
  const { className, rightNode, value } = props;

  if (!value.length && !rightNode) {
    return null;
  }
  return (
    <div className={clsx('flex items-center justify-between', className)}>
      <Breadcrumb
        separator={<FoxIconRightSm className="align-middle" size={14} />}
        className={clsx('w-0 flex-1 text-[14px] leading-base', styles['docs-breadcrumb'])}
      >
        {value.map((x) => {
          return <Breadcrumb.Item key={x.key}>{x.name}</Breadcrumb.Item>;
        })}
      </Breadcrumb>

      <div className="flex items-center gap-2">{rightNode}</div>
    </div>
  );
}
